import { useParams, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import APIs from "../../APIs";
import Sidebar from "./Sidebar";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripePayment from "./StripePayment";
import { useDispatch } from "react-redux";
import {
  addItem,
  setPickupDate,
  setPickupTime,
  setCategoryId,
  setCustomTime,
  setUrgencyLevel,
  setShipmentId,
  setpo_number,
  setItems,
} from "../../redux/shipmentSlice";
import {
  setPickupAddress as setPickupAddressAddr,
  setDropoffAddress as setDropoffAddressAddr,
} from "../../redux/addressSlice";
const stripePromise = loadStripe(
  "pk_live_51SebhJGeo3OIESq51cERjNUpf69lOXxdPsjBtYhwLQvmLJXpYBgrJFPbHZkJac709gpJw1Telz0Z35p8O8pfcu5V00fkfMwIe0"
);

const QuoteDetails = () => {
  const { quoteId } = useParams();
  const [quote, setQuote] = useState(null);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [checkoutSessionId, setCheckoutSessionId] = useState("");
  const [checkoutSessionUrl, setCheckoutSessionUrl] = useState("");
  const [flightDetails2, setFlightDetails2] = useState([]);
  const [showStops, setShowStops] = useState(false);
  const [segments, setSegments] = useState([]); // whole array stored here
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const userId = userData?.user_id;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Store current quote ID in session
  useEffect(() => {
    if (quote?.quote_id) {
      sessionStorage.setItem("currentQuoteId", quote.quote_id);
    }
  }, [quote]);

  // ==============================
  // FETCH STRIPE SESSION URL
  // ==============================
  const fetchSessionUrl = async (quoteData) => {
    try {
      const res = await APIs.post("payment/getSessionIdForPayment", {
        amount: quoteData.total_pay_amount,
        currency: "USD",
        quote_id: quoteData.quote_id, // optional for backend linking
      });

      const sessionData = res.data.data;

      if (sessionData?.url) {
        setCheckoutSessionUrl(sessionData.url);
        setCheckoutSessionId(sessionData.id);
        console.log("Stripe session ID:", sessionData.id);
      }

      if (sessionData?.client_secret) {
        setClientSecret(sessionData.client_secret);
        if (sessionData.stripe_pay_id) {
          sessionStorage.setItem("stripePayId", sessionData.stripe_pay_id);
        }
        console.log("Stripe Pay ID:", sessionData.stripe_pay_id);
      }

      return sessionData;
    } catch (err) {
      console.error("Error fetching Stripe session URL:", err);
      return null;
    }
  };


  // Fetch Quote Details
  useEffect(() => {
    const fetchQuote = async () => {
      try {
        if (!quoteId) return;

        const res = await APIs.post(
          "quote/getQuoteById",
          { quote_id: quoteId },
          { headers: { "Content-Type": "application/json" } }
        );

        const quoteData = res.data?.data || null;
        setQuote(quoteData);
        console.log("quote data ===", quoteData);

        if (!quoteData) return;

        // Dispatch shipment & category info
        if (quoteData.shipment_id) {
          dispatch(setShipmentId(quoteData.shipment_id));
          sessionStorage.setItem("shipment_id", quoteData.shipment_id);
        }

        dispatch(setCategoryId(quoteData.category?.category_id));
        sessionStorage.setItem("categoryName", quoteData.category?.category_name || "");
        sessionStorage.setItem("categoryDescription", quoteData.category?.category_description || "");
        dispatch(setPickupAddressAddr(quoteData.pickup_address || {}));
        dispatch(setDropoffAddressAddr(quoteData.drop_address || {}));
        setFlightDetails2(quoteData.select_flight)
        setSegments(quoteData.select_flight.segments)
        // Map items (keep as is)
        const mappedItems = await Promise.all(
          (quoteData.items || []).map(async (item, idx) => {
            let previewImage = item.item_image || "";
            let file = null;

            if (previewImage && typeof previewImage === "string") {
              try {
                const fileName = previewImage.split("/").pop() || `item-${idx}.jpg`;
                const ext = fileName.split(".").pop()?.toLowerCase();
                const mimeType =
                  ext === "png"
                    ? "image/png"
                    : ext === "gif"
                      ? "image/gif"
                      : "image/jpeg";

                const response = await fetch(previewImage);
                const blob = await response.blob();

                file = new File([blob], fileName, {
                  type: mimeType,
                  lastModified: Date.now(),
                });
              } catch (err) {
                console.warn("Image fetch failed, fallback to null:", err);
              }
            }

            return {
              box: item.item_box_type || "",
              itemTitle: item.item_name || "",
              itemWidth: item.item_width || "",
              itemHeight: item.item_height || "",
              itemLength: item.item_length || "",
              itemWeight: item.item_weight || "",
              description: item.item_description || "",
              file: file,
              preview: previewImage,
              quantity: item.item_qty || 1,
            };
          })
        );

        console.log("Map items==", mappedItems);
        dispatch(setItems(mappedItems));

        // Other shipment details
        dispatch(
          setpo_number(
            quoteData?.shipment?.po_number || quoteData?.po_number || ""
          )
        );

        const pickupDateStr = (() => {
          const d = quoteData?.shipment?.pickup_date;
          if (!d) return "";
          try {
            const dt = new Date(d);
            if (isNaN(dt)) return String(d).slice(0, 10);
            return dt.toISOString().split("T")[0];
          } catch {
            return String(d).slice(0, 10);
          }
        })();

        dispatch(setPickupDate(pickupDateStr));
        dispatch(setPickupTime(quoteData?.shipment?.pickup_time || ""));
        dispatch(setCustomTime(quoteData?.shipment?.custom_time || ""));
        dispatch(setUrgencyLevel(quoteData?.shipment?.urgency_level || ""));

        // ✅ Prevent extra payment API calls after booking
        const skipPayment = sessionStorage.getItem("skipPaymentFetch");

        // ✅ Only fetch Stripe session when quote is "Submitted" and not "Booked"
        if (
          !skipPayment &&
          quoteData?.status === "Submitted" &&
          quoteData?.shipment?.status !== "Booked"
        ) {
          await fetchSessionUrl(quoteData);
        }

        // ✅ Clear flag after use
        if (skipPayment) {
          sessionStorage.removeItem("skipPaymentFetch");
        }

      } catch (err) {
        console.error("Error fetching quote:", err);
      }
    };

    fetchQuote();
  }, [quoteId, userId]);



  if (!quote)
    return <p className="text-center my-5">Loading Quote...</p>;

  // ==============================
  // HANDLE PAY NOW
  // ==============================
  const handlePayNow = async () => {
    if (!quote) {
      alert("Quote not loaded");
      return;
    }

    setCheckoutLoading(true);
    try {
      // 1️⃣ Create Stripe payment session only now (not earlier)
      const sessionData = await fetchSessionUrl(quote);

      if (!sessionData) {
        throw new Error("Unable to create payment session. Please try again.");
      }

      // 2️⃣ Save transaction details (only during Pay Now flow)
      try {
        await APIs.post("payment/getPaymentDetailsByUserId", {
          user_id: userId,
          shipment_id: quote.shipment_id,
          amount: quote.total_pay_amount,
          currency: "USD",
          quote_id: quoteId,
          stripe_pay_id: sessionData?.stripe_pay_id || sessionData?.id || "",
        });
        console.log("Payment details saved successfully before redirect.");
      } catch (err) {
        console.error("Error saving payment details before redirect:", err);
        // optional: toast.warn("Payment details not saved, but continuing...");
      }

      // 3️⃣ Redirect user to Stripe checkout page
      if (sessionData.url) {
        window.location.href = sessionData.url;
      } else {
        throw new Error("Payment session URL not available.");
      }
    } catch (error) {
      console.error("Payment error:", error);
      alert(error.message || "Payment failed");
    } finally {
      setCheckoutLoading(false);
    }
  };

  // ==============================
  // HANDLE BOOK NOW
  // ==============================
  const handleBookNow = async (quoteData) => {
    try {
      // clear any previous Stripe session data
      sessionStorage.removeItem("stripePayId");

      const res = await APIs.post("booking/addBookingWithoutPayment", {
        user_id: userId,
        shipment_id: quote.shipment_id,
      });

      console.log("Booking response:", res.data);

      if (res.data?.status?.toLowerCase() === "success") {
        // ✅ Show Success Modal
        const modalEl = document.getElementById("sucessModalToggle");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      } else {
        // ❌ Show Fail Modal
        const failModalEl = document.getElementById("failModalToggle");
        const failModal = new window.bootstrap.Modal(failModalEl);
        failModal.show();
      }
    } catch (err) {
      console.error("Booking error:", err);
      const failModalEl = document.getElementById("failModalToggle");
      const failModal = new window.bootstrap.Modal(failModalEl);
      failModal.show();
    }
  };




  // For "Dashboard" button inside modal
  // const handleClick = () => {
  //    navigate(`/quotationdetails/${quoteId}`); // if you prefer route reload instead
  //  // window.location.reload(); // redirect same page (reload)

  // };
  // Inside handleClick
  const handleClick = () => {
    sessionStorage.setItem("skipPaymentFetch", "true"); // prevent payment refetch
    navigate(`/quotationdetails/${quoteId}`);
    window.location.reload();
  };

  // Extract select_flight safely
  const selectFlight = quote?.select_flight;

  // Reusable for Auto + Manual
  const segments2 =
    selectFlight?.segments ||
    selectFlight?.parsedFlight?.itineraries?.[0]?.segments ||
    [];

  // // ✅ Show only when status is "Submitted"
  // if (quote?.status !== "Submitted") return null;

  const getEstimatedDelivery = (flight) => {
    const pickupDate = new Date(quote.shipment.pickup_date); // or API pickup time
    const estimated = new Date(
      pickupDate.getTime() + flight.total_time_hr * 60 * 60 * 1000
    );

    return new Date(estimated.toLocaleString()).toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  };

  return (
    <div className="page-content">
      <section className="step-section-md">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3">
              <Sidebar />
            </div>

            {/* Quote Details */}
            <div className="col-lg-9">
              <a
                className="btn btn-primary d-inline-block mb-4 d-lg-none"
                data-bs-toggle="offcanvas"
                href="#offcanvasExample"
                role="button"
              >
                Show Menu
              </a>

              <div className="row">
                {/* Left Side */}
                <div className="col-lg-6">
                  <div className="shipment-information-new">
                    <div className="new-title">
                      <h3>{quote.category.category_name}</h3>
                      <p>{quote.category.category_description}</p>
                    </div>

                    {/* Pickup & Drop */}
                    <div className="form-to-location">
                      <div className="form-location">
                        <div className="icon-ftl">
                          <i className="ti-arrow-up"></i>
                        </div>
                        <div className="flex-1">
                          <label>Pickup</label>
                          <h3>{quote.pickup_address?.address_type}</h3>
                          <span>
                            {quote.pickup_address?.address}, {quote.pickup_address?.city},{" "}
                            {quote.pickup_address?.state} {quote.pickup_address?.zip_code}
                          </span>
                        </div>
                        {quote?.shipment?.status !== "Booked" && (
                          <Link to="/address?type=pickup" className="edite-icon">
                            <i className="ti-pencil" />
                          </Link>
                        )}
                      </div>
                      <div className="to-location">
                        <div className="icon-ftl">
                          <i className="ti-arrow-down"></i>
                        </div>
                        <div className="flex-1">
                          <label>Drop-off</label>
                          <h3>{quote.drop_address?.address_type}</h3>
                          <span>
                            {quote.drop_address?.address}, {quote.drop_address?.city},{" "}
                            {quote.drop_address?.state} {quote.drop_address?.zip_code}
                          </span>
                        </div>
                        {quote?.shipment?.status !== "Booked" && (
                          <Link to="/address?type=dropoff" className="edite-icon">
                            <i className="ti-pencil" />
                          </Link>
                        )}
                      </div>
                    </div>

                    {/* Items Section */}
                    {quote?.status === "Submitted" && (
                      <div className="vehicle-detail-new">
                        <div className="icon-ftl">
                          <i className="ti-archive"></i>
                        </div>
                        <div className="flex-1 overflow-hidden">
                          <label className="mb-1">What Are You Transporting?</label>
                          <div className="row">
                            {quote.items?.map((item) => (
                              <div className="col-md-6" key={item.item_id}>
                                <div className="shipment-item-container">
                                  <div className="shipment-item-img">
                                    <img
                                      src={item.item_image || "/images/defaultImage.jpg"}
                                      className="img-fluid"
                                      alt={item.item_name}
                                    />
                                  </div>
                                  <div className="shipment-item-details">
                                    <h5>{item.item_name}</h5>
                                    <p className="small mb-1">{item.item_description}</p>
                                    <p className="small mb-1">
                                      Size: Height {item.item_height} cm × Width {item.item_width} cm × Length {item.item_length} cm
                                    </p>
                                    <p className="small mb-1">Box Weight: {item.item_weight || 0} kg</p>
                                    <p className="small mb-1">Quantity: {item.item_qty}</p>
                                    <p className="small mb-1">
                                      Total Weight: {(item?.item_qty * item?.item_weight || 0)} kg
                                    </p>


                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        {quote?.shipment?.status !== "Booked" && (
                          <Link to="/Step3" className="edite-icon">
                            <i className="ti-pencil" />
                          </Link>
                        )}
                      </div>
                    )}

                    {/* Pickup Time */}
                    <div className="vehicle-detail-new mb-0">
                      <div className="icon-ftl">
                        <i className="ti-calendar"></i>
                      </div>
                      <div className="flex-1">
                        <label>Pickup Time</label>
                        <h3>
                          {new Date(quote.shipment.pickup_date).toDateString()} at{" "}
                          {quote.shipment.pickup_time}
                        </h3>
                        <h3>
                          <label>Estimated Delivery:</label>{" "}
                          {quote?.select_flight ? getEstimatedDelivery(quote?.select_flight) : "Loading..."}
                        </h3>
                        <p>Urgency level : {quote.shipment.urgency_level}</p>
                      </div>
                      {quote?.shipment?.status !== "Booked" && (
                        <Link to="/Step4" className="edite-icon">
                          <i className="ti-pencil" />
                        </Link>
                      )}

                    </div>
                  </div>
                </div>

                {/* Right Side */}
                <div className="col-lg-6">
                  <div className="shipment-details-new p-0">
                    {quote?.status === 'Requested' && flightDetails2 != null ?
                      <div className="card mb-3">
                        <div className="card-body">
                          <h5>Flight Details</h5>

                          <div className="fligh-detail-wrapper">
                            <div className="fligh-detail flex-1">

                              {/* Airline + Flight Number */}
                              <div className="d-flex gap-3 mb-3">
                                <img
                                  src={`https://daisycon.io/images/airline/?width=120&height=80&iata=${segments?.[0]?.carrierCode}`}
                                  className="img-fluid"
                                  alt="Airline Logo"
                                />

                                <div>
                                  <h5 className="mb-0">{segments?.[0]?.carrierCode || "N/A"}</h5>
                                  <p className="mb-0">
                                    {segments?.map(s => s.number).join(", ") || "N/A"}
                                  </p>
                                </div>
                              </div>

                              {/* From - Stops - To */}
                              <div className="flight-from-to gap-2">

                                {/* Departure */}
                                <div className="form-lo text-center">
                                  <h5 style={{ fontSize: 12 }}>
                                    {segments?.[0]?.departure?.at
                                      ? new Date(segments[0].departure.at).toLocaleTimeString([], {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })
                                      : "N/A"}
                                  </h5>

                                  <p className="mb-0">{flightDetails2?.origin_airport?.iata_code || "N/A"}</p>
                                </div>

                                {/* Center Section */}
                                <div className="total-time text-center">
                                  <h5 className="mb-0">{flightDetails2?.flight_duration_hr || "N/A"} hrs</h5>

                                  <hr style={{ margin: "5px 0", borderTop: "3px solid" }} />

                                  <p className="mb-0">
                                    {segments?.length > 1 ? `${segments.length - 1} Stop(s)` : "Non stop"}
                                  </p>

                                  {segments?.length > 1 && (
                                    <button
                                      className="btn btn-link p-0 mt-1"
                                      onClick={() => setShowStops(!showStops)}
                                      style={{ fontSize: "14px" }}
                                    >
                                      {showStops ? "Hide Stops" : "View Stops"}
                                    </button>
                                  )}
                                </div>

                                {/* Arrival */}
                                <div className="to-lo text-center">
                                  <h5 style={{ fontSize: 12 }}>
                                    {segments?.[segments.length - 1]?.arrival?.at
                                      ? new Date(
                                        segments[segments.length - 1].arrival.at
                                      ).toLocaleTimeString([], {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })
                                      : "N/A"}
                                  </h5>

                                  <p className="mb-0">{flightDetails2?.dest_airport?.iata_code || "N/A"}</p>
                                </div>
                              </div>

                              {/* Collapsible Stops Section */}
                              {showStops && (
                                <div className="my-2 p-2 border rounded bg-light">

                                  {segments.map((seg, index) => (
                                    <div key={index} className="d-flex justify-content-between mb-2">

                                      <div>
                                        <strong>From:</strong> {seg.departure.iataCode}
                                        <br />
                                        <span>
                                          {new Date(seg.departure.at).toLocaleTimeString([], {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}
                                        </span>
                                      </div>
                                      {/* Dotted Line with Airplane */}
                                      <div className="flight-middle flex-grow-1 px-2 bg-light align-self-center">
                                        <div className="flight-line"></div>
                                        <span className="flight-icon bg-light">✈</span>
                                      </div>
                                      <div>
                                        <strong>To:</strong> {seg.arrival.iataCode}
                                        <br />
                                        <span>
                                          {new Date(seg.arrival.at).toLocaleTimeString([], {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}
                                        </span>
                                      </div>

                                    </div>
                                  ))}

                                </div>
                              )}
                            </div>
                          </div>
                          <div>
                            <div className="fligh-cost">
                              <h5 className="mb-0">Total Carrier Charges</h5>
                              <h5 className="mb-0">{quote.currency_symbol} {quote.total_carrier_charges}</h5>
                            </div>

                            <hr />

                            <h5>Handling Charges</h5>
                            <div className="fligh-detail-wrapper">
                              <div className="fligh-detail flex-1">
                                <div className="d-flex justify-content-between mb-1">
                                  <p className="mb-0">Custom Clearance Charges</p>
                                  <p className="mb-0">{quote.currency_symbol} {parseFloat(quote.custom_clearance_charges).toFixed(2)}</p>
                                </div>
                                <div className="d-flex justify-content-between mb-1">
                                  <p className="mb-0">Documentation Charges</p>
                                  <p className="mb-0">{quote.currency_symbol} {parseFloat(quote.documentation_charges).toFixed(2)}</p>
                                </div>
                                <div className="d-flex justify-content-between mb-1">
                                  <p className="mb-0">Other Charges</p>
                                  <p className="mb-0">{quote.currency_symbol} {parseFloat(quote.other_charges).toFixed(2)}</p>
                                </div>
                              </div>
                              <div className="fligh-cost mb-1">
                                <h5 className="mb-0">Total Handling Charges</h5>
                                <h5 className="mb-0">{quote.currency_symbol} {parseFloat(quote.total_handling_charges).toFixed(2)}</h5>
                              </div>
                              <div className="fligh-cost mb-1">
                                <h5 className="mb-0">Service Charges</h5>
                                <h5 className="mb-0">{quote.currency_symbol} {Number(quote?.admin_commission_charges || 0)}</h5>
                              </div>
                              <div className="fligh-cost d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center gap-1">
                                  <h5 className="mb-0">Any Other Charges</h5>

                                  <span
                                    title={
                                      Array.isArray(quote?.extra_charges) &&
                                        quote.extra_charges.length > 0
                                        ? quote.extra_charges
                                          .map(
                                            (c) =>
                                              `${c?.charge_name || "Charge"}: ${quote?.currency_symbol || ""
                                              }${c?.charge_value ?? 0}`
                                          )
                                          .join("\n")
                                        : "No extra charges"
                                    }
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "11px",
                                      color: "#6c757d",
                                      border: "1px solid #6c757d",
                                      borderRadius: "50%",
                                      width: "16px",
                                      height: "16px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      lineHeight: "1",
                                    }}
                                  >
                                    ℹ
                                  </span>
                                </div>

                                <h5 className="mb-0">
                                  {quote?.currency_symbol || ""}
                                  {Number(quote?.total_extra_charges || 0).toFixed(2)}
                                </h5>
                              </div>
                            </div>

                            <hr />

                            <div className="fligh-cost">
                              <h5 className="mb-0">Total Pay Amount</h5>
                              <h3 className="commen-h3-title mb-0">{quote.currency_symbol} {Number(quote?.total_pay_amount || 0)}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      : null}

                    {quote.status === 'Submitted' ? (
                      <div className="card mb-3">
                        <div className="card-body">
                          <h5>Flight Details</h5>

                          <div className="fligh-detail-wrapper">
                            <div className="fligh-detail flex-1">

                              {/* Airline + Flight Number */}
                              <div className="d-flex gap-3 mb-3 align-items-center">
                                <img
                                  src={`https://daisycon.io/images/airline/?width=120&height=80&iata=${segments2?.[0]?.carrierCode}`}
                                  className="img-fluid"
                                  alt="Airline Logo"
                                />

                                <div>
                                  <h5 className="mb-0">
                                    {segments2?.[0]?.carrierCode || "N/A"}
                                  </h5>
                                  <p className="mb-0">
                                    {segments2.length
                                      ? segments2.map(s => s.number).join(", ")
                                      : "N/A"}
                                  </p>
                                </div>
                              </div>

                              {/* From - Stops - To */}
                              <div className="flight-from-to d-flex justify-content-between align-items-center">

                                {/* Departure */}
                                <div className="form-lo text-center">
                                  <h5>
                                    {segments2?.[0]?.departure?.at
                                      ? new Date(
                                        segments2[0].departure.at
                                      ).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })
                                      : "N/A"}
                                  </h5>
                                  <p className="mb-0">
                                    {selectFlight?.origin_airport?.iata_code || "N/A"}
                                  </p>
                                </div>

                                {/* Center */}
                                <div className="total-time text-center">
                                  <h5 className="mb-0">
                                    {selectFlight?.flight_duration_hr || "N/A"} hrs
                                  </h5>

                                  <hr style={{ margin: "5px 0", borderTop: "3px solid" }} />

                                  <p className="mb-0">
                                    {segments2.length > 1
                                      ? `${segments2.length - 1} Stop(s)`
                                      : "Non stop"}
                                  </p>

                                  {segments2.length > 1 && (
                                    <button
                                      className="btn btn-link p-0 mt-1"
                                      onClick={() => setShowStops(!showStops)}
                                      style={{ fontSize: "14px" }}
                                    >
                                      {showStops ? "Hide Stops" : "View Stops"}
                                    </button>
                                  )}
                                </div>

                                {/* Arrival */}
                                <div className="to-lo text-center">
                                  <h5>
                                    {segments2?.[segments2.length - 1]?.arrival?.at
                                      ? new Date(
                                        segments2[segments2.length - 1].arrival.at
                                      ).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })
                                      : "N/A"}
                                  </h5>
                                  <p className="mb-0">
                                    {selectFlight?.dest_airport?.iata_code || "N/A"}
                                  </p>
                                </div>

                              </div>

                              {/* Stops Section */}
                              {showStops && (
                                <div className="my-2 p-2 border rounded bg-light">

                                  {segments2.map((seg, index) => (
                                    <div
                                      key={index}
                                      className="d-flex justify-content-between align-items-center mb-2"
                                    >
                                      <div>
                                        <strong>From:</strong> {seg.departure.iataCode}
                                        <br />
                                        <span>
                                          {new Date(seg.departure.at).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}
                                        </span>
                                      </div>

                                      <div className="flight-middle flex-grow-1 px-2 align-self-center">
                                        <div className="flight-line"></div>
                                        <span className="flight-icon">✈</span>
                                      </div>

                                      <div>
                                        <strong>To:</strong> {seg.arrival.iataCode}
                                        <br />
                                        <span>
                                          {new Date(seg.arrival.at).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}
                                        </span>
                                      </div>
                                    </div>
                                  ))}

                                </div>
                              )}

                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {/* ✅ Show Quotation Prices Block */}
                    {quote?.status === "Submitted" ? (
                      <>
                        {/* ====== Price Details Card ====== */}
                        <div className="card mb-3">
                          <div className="card-body">
                            {/* Flight Details (if present) */}
                            {quote.airline && quote.flight_number && (
                              <>
                                <h5>Flight Details</h5>
                                <div className="fligh-detail-wrapper">
                                  <div className="fligh-detail flex-1">
                                    <div className="d-flex gap-3 mb-3">
                                      <img
                                        src={`https://daisycon.io/images/airline/?width=120&height=80&iata=${quote.airline}`}
                                        className="img-fluid"
                                        alt="airline"
                                      />
                                      <div>
                                        <h5 className="mb-0">{quote.airline}</h5>
                                        <p className="mb-0">{quote.flight_number}</p>
                                      </div>
                                    </div>
                                    <div className="flight-from-to">
                                      <div className="form-lo text-center">
                                        <h5>
                                          {new Date(quote.scheduled_departure).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}
                                        </h5>
                                        <p className="mb-0">{quote.departure_city}</p>
                                      </div>
                                      <div className="total-time text-center">
                                        <h5 className="mb-0">—</h5>
                                        <hr style={{ margin: "5px 0", borderTop: "3px solid" }} />
                                        <p className="mb-0">Non stop</p>
                                      </div>
                                      <div className="to-lo text-center">
                                        <h5>
                                          {new Date(quote.scheduled_arrival).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}
                                        </h5>
                                        <p className="mb-0">{quote.arrival_city}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="fligh-cost">
                                    <h5 className="mb-0">Total Flight Charges</h5>
                                    <h5 className="mb-0">{quote.currency_symbol} {Number(quote.total_carrier_charges).toFixed(2)}</h5>
                                  </div>
                                </div>
                                <hr />
                              </>
                            )}

                            {/* Carrier + Handling + Total */}
                            <div>
                              <div className="fligh-cost">
                                <h5 className="mb-0">Total Carrier Charges</h5>
                                <h5 className="mb-0">{quote.currency_symbol} {Number(quote.total_carrier_charges).toFixed(2)}</h5>
                              </div>

                              <hr />

                              <h5>Handling Charges</h5>
                              <div className="fligh-detail-wrapper">
                                <div className="fligh-detail flex-1">
                                  <div className="d-flex justify-content-between mb-1">
                                    <p className="mb-0">Custom Clearance Charges</p>
                                    <p className="mb-0">{quote.currency_symbol} {parseFloat(quote.custom_clearance_charges).toFixed(2)}</p>
                                  </div>
                                  <div className="d-flex justify-content-between mb-1">
                                    <p className="mb-0">Documentation Charges</p>
                                    <p className="mb-0">{quote.currency_symbol} {parseFloat(quote.documentation_charges).toFixed(2)}</p>
                                  </div>
                                  <div className="d-flex justify-content-between mb-1">
                                    <p className="mb-0">Other Charges</p>
                                    <p className="mb-0">{quote.currency_symbol} {parseFloat(quote.other_charges).toFixed(2)}</p>
                                  </div>
                                </div>
                                <div className="fligh-cost mb-1">
                                  <h5 className="mb-0">Total Handling Charges</h5>
                                  <h5 className="mb-0">{quote.currency_symbol} {parseFloat(quote.total_handling_charges).toFixed(2)}</h5>
                                </div>
                                <div className="fligh-cost mb-1">
                                  <h5 className="mb-0">Service Charges</h5>
                                  <h5 className="mb-0">{quote.currency_symbol} {parseFloat(quote.admin_commission_charges).toFixed(2)}</h5>
                                </div>
                                <div className="fligh-cost d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center gap-1">
                                    <h5 className="mb-0">Any Other Charges</h5>

                                    <span
                                      title={
                                        Array.isArray(quote?.extra_charges) &&
                                          quote.extra_charges.length > 0
                                          ? quote.extra_charges
                                            .map(
                                              (c) =>
                                                `${c?.charge_name || "Charge"}: ${quote?.currency_symbol || ""
                                                }${c?.charge_value ?? 0}`
                                            )
                                            .join("\n")
                                          : "No extra charges"
                                      }
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "11px",
                                        color: "#6c757d",
                                        border: "1px solid #6c757d",
                                        borderRadius: "50%",
                                        width: "16px",
                                        height: "16px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        lineHeight: "1",
                                      }}
                                    >
                                      ℹ
                                    </span>
                                  </div>

                                  <h5 className="mb-0">
                                    {quote?.currency_symbol || ""}
                                    {Number(quote?.total_extra_charges || 0).toFixed(2)}
                                  </h5>
                                </div>
                              </div>

                              <hr />

                              <div className="fligh-cost">
                                <h5 className="mb-0">Total Pay Amount</h5>
                                <h3 className="commen-h3-title mb-0">{quote.currency_symbol} {parseFloat(quote.total_pay_amount).toFixed(2)}</h3>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ====== Payment or Transaction Section ====== */}
                        <div className="card mb-3">
                          <div style={{ display: "contents" }}>
                            {/* If quote already booked — show transaction details */}
                            {quote?.transaction ? (
                              <div className="card p-3 shadow-sm">
                                <h5 className="mb-3">Transaction Details</h5>
                                <div className="fligh-detail-wrapper">
                                  <div className="fligh-detail flex-1">
                                    <div className="d-flex justify-content-between mb-2">
                                      <p className="mb-0">Transaction ID</p>
                                      <p className="mb-0">
                                        <strong>{quote.transaction.stripe_transaction_id || "-"}</strong>
                                      </p>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                      <p className="mb-0">Payment Mode</p>
                                      <p className="mb-0">
                                        <strong>{quote.transaction.payment_method || "-"}</strong>
                                      </p>
                                    </div>
                                    <div className="d-flex justify-content-between mb-0">
                                      <p className="mb-0">Payment Status</p>
                                      <p className="mb-0">
                                        <strong>{quote.transaction.status || "-"}</strong>
                                      </p>
                                    </div>
                                  </div>
                                  <div className="fligh-cost">
                                    <h5 className="mb-0">Total Paid Amount</h5>
                                    <h3 className="commen-h3-title mb-0">
                                      {quote.currency_symbol}
                                      {Number(quote.transaction.amount).toFixed(2)}
                                    </h3>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>
                                {/* If not booked and no transaction yet */}
                                <>
                                  {/* If quote exists and has payment info */}
                                  {quote?.payment_info && (
                                    <>
                                      {(() => {
                                        const todayStr = new Date().toISOString().slice(0, 10);
                                        const dueDateStr = new Date(quote.payment_info.payment_due_date)
                                          .toISOString()
                                          .slice(0, 10);

                                        const isImmediate =
                                          quote.payment_info.payment_term_name === "Immediate" ||
                                          quote.payment_info.payment_term_id === 1;

                                        const isDue = dueDateStr <= todayStr;

                                        const paymentPending = quote?.paymentTransactionHistory?.status == "Pending";

                                        // ✅ Case 1: Payment due or immediate & not yet paid → show active Pay Now
                                        if ((paymentPending || quote?.paymentTransactionHistory == null) && quote.term_days == 0) {
                                          return (
                                            <button
                                              className="btn btn-success btn-lg flex-1"
                                              onClick={handlePayNow}
                                              disabled={checkoutLoading}
                                            >
                                              {checkoutLoading ? "Processing..." : "Pay Now"}
                                            </button>
                                          );
                                        }

                                        // 🚫 Case 2: Payment not due yet → show blurred Pay Now (disabled)
                                        // if (paymentPending && !isImmediate && !isDue) {
                                        //   return (
                                        //     <button
                                        //       className="btn btn-success btn-lg flex-1"
                                        //       style={{
                                        //         opacity: 0.6,
                                        //         cursor: "not-allowed",
                                        //         filter: "blur(0.5px)",
                                        //       }}
                                        //       disabled
                                        //     >
                                        //       Pay Now
                                        //     </button>
                                        //   );
                                        // }

                                        // ✅ Case 3: Not booked and quote submitted → show Book Now
                                        if (
                                          quote.term_days > 0 && quote?.shipment?.status == "Requested"
                                        ) {
                                          return (
                                            <button
                                              className="btn btn-success btn-lg flex-1"
                                              onClick={() => handleBookNow(quote)}
                                            >
                                              Book Now
                                            </button>
                                          );
                                        }

                                        return null;
                                      })()}

                                      {/* Payment Info Note */}
                                      {/* <p
                                        style={{
                                          color: "red",
                                          marginTop: "10px",
                                          paddingLeft: "10px",
                                        }}
                                      >
                                        {quote.term_days === 0
                                          ? "Immediate payment required."
                                          : quote.payment_info.payment_due_in}
                                      </p> */}
                                    </>
                                  )}

                                </>

                              </>
                            )}
                          </div>
                        </div>

                      </>
                    ) : (
                      <>
                        {/* ✅ When showQuotationPrices !== "false" — Show Shipment Items */}
                        <div className="card mb-3">
                          <div className="card-body">

                            <div className="flex-1 overflow-hidden">
                              <label className="mb-1">What Are You Transporting?</label>
                              <div className="row">
                                {quote?.shipment?.status !== "Booked" && (
                                  <Link to="/Step3" className="edite-icon mb-1">
                                    <i className="ti-pencil float-end" />
                                  </Link>
                                )}
                                {quote.items?.map((item) => (
                                  <div className="col-md-6" key={item.item_id}>
                                    <div className="shipment-item-container">
                                      <div className="shipment-item-img">
                                        <img
                                          src={item.item_image || "/images/defaultImage.jpg"}
                                          className="img-fluid"
                                          alt={item.item_name}
                                        />
                                      </div>
                                      <div className="shipment-item-details">
                                        <h5>{item.item_name}</h5>
                                        <p className="small mb-1">{item.item_description}</p>
                                        <p className="small mb-1">
                                          Size: Height {item.item_height} cm × Width {item.item_width} cm × Length {item.item_length} cm
                                        </p>
                                        <p className="small mb-1">Box Weight: {item.item_weight || 0} kg</p>
                                        <p className="small mb-1">Quantity: {item.item_qty}</p>
                                        <p className="small mb-1">
                                          Total Weight: {(item?.item_qty * item?.item_weight || 0)} kg
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ))}

                              </div>
                            </div>


                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* End right side */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Success Modal */}
      <div className="modal fade" id="sucessModalToggle" aria-hidden="true" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              <img src="/images/sucess.jpg" className="img-fluid sucess-img" alt="success" />
              <h5 className="modal-title">Request Submitted!</h5>
              <p>
                Your booking has been confirmed.
              </p>
              <button className="btn btn-success" onClick={handleClick}>
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="failModalToggle" aria-hidden="true" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              {/* <button type="button" className="btn-close float-r" data-bs-dismiss="modal" aria-label="Close"></button> */}
              <img src="/images/payment_fail.png" className="img-fluid sucess-img" alt="payment failed" />

              <h5 className="modal-title text-danger">Booking Failed</h5>
              <p>
                Oops! Something went wrong while submitting your booking request.
                Please try again later or contact support if the problem persists.
              </p>
              <button
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => window.location.reload()}
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default QuoteDetails;
